import i18n from 'i18next';

export const i18nNamespaceLoader = (namespaces: string | string[]) => async () => {
  const namespaceList = Array.isArray(namespaces) ? namespaces : [namespaces];
  await i18n.loadNamespaces(namespaceList);
  return null;
};

import type { ApiAcceptedLanguage } from '@izimi/api';

const languageString: Record<ApiAcceptedLanguage, string> = {
  en: 'English',
  fr: 'Français',
  nl: 'Nederlands',
  de: 'Deutsch',
};

export const getLanguageString = (locale: ApiAcceptedLanguage) => languageString[locale];
